import { FC, Fragment } from 'react';
import styles from './project-info.module.scss';
import { IProjectInfo } from '@components/projects/level01/level01.state';
import Image from 'next/image';
import Level01Animation from '@components/projects/level01/animations';
import animations from '@components/projects/level01/animations/animations.module.scss';

interface ProjectInfoSectionProps {
    section: IProjectInfo;
}

const ProjectInfoSection: FC<ProjectInfoSectionProps> = ({ section: { title, iconUrl, info, project, solutions } }) => {
    return (
        <Level01Animation render={(ref) => (
          <div className={styles.container}>
              <section ref={ref} className={`${styles.section} ${animations.scroll__animation}`}>
                  <h2 className={styles.section__title}>{title}</h2>
                  <div className={styles.section__content}>
                      <div className={styles.section__project}>
                          <h3 className={styles.section__project_title}>{project.title}</h3>
                          <span className={styles.section__project_subtitle}>{project.subtitle}</span>
                      </div>
                      <div className={styles.section__info}>
                          {info.blocks.map((item, idx) => (
                            <div key={idx} className={styles.section__info_block}>
                                <h3 className={styles.section__info_title}>{item.title}</h3>
                                <span className={styles.section__info_subtitle}>{item.subtitle}</span>
                            </div>
                          ))}
                      </div>
                      <div className={styles.section__solutions}>
                          <h3 className={styles.section__solutions_title}>{solutions.title}</h3>
                          <div className={styles.section__solutions_blocks}>
                              {solutions.content.map((item, idx) => (
                                <div key={idx} className={styles.section__solutions_block}>
                                    <div className={styles.section__solutions_block_img}>
                                        <Image src={iconUrl} alt={'Checked icon'} layout={'fill'}/>
                                    </div>
                                    <p className={styles.section__solutions_block_title}>{item}</p>
                                </div>
                              ))}
                          </div>
                      </div>
                  </div>
              </section>
          </div>
        )}/>
    )
}

export default ProjectInfoSection;
